import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback } from "react";
import { Spinner } from "reactstrap";
import Swal from "sweetalert2";
import Flatpickr from "react-flatpickr";
import PhoneInput from 'react-phone-input-2';
import Cropper from "react-easy-crop";
import Dropzone from "react-dropzone";
import {
  Container,
  Row,
  Col,
  Card,
  CardText,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Button,
  Form,
  FormFeedback,
  Label,
  Input
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import classnames from "classnames";

// Redux
import { connect, useDispatch } from "react-redux";
import withRouter from 'components/Common/withRouter';

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// actions
import { editProfile, resetProfileFlag } from "../../store/actions";

/* ---------------- IMAGE CROP HELPERS ---------------- */
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = url;
  });

async function getCroppedImg(imageSrc, cropPixels) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = 210;
  canvas.height = 210;

  if (!ctx) return "";

  ctx.drawImage(
    image,
    cropPixels.x,
    cropPixels.y,
    cropPixels.width,
    cropPixels.height,
    0,
    0,
    210,
    210
  );

  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      if (!blob) return resolve("");
      resolve(URL.createObjectURL(blob));
    }, "image/jpeg");
  });
}

const UserProfile = props => {
  const dispatch = useDispatch();

  const [id, setid] = useState(1);
  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [parentName, setparentName] = useState("");
  const [phone, setphone] = useState("");
  const [phone2, setphone2] = useState("");
  const [dob, setdob] = useState("");
  const [address, setaddress] = useState("");
  const [role, setrole] = useState("");
  const [imageurl, setimageurl] = useState("");
  const [oldpassword, setoldpassword] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [finalImage, setFinalImage] = useState(null);
  const token = localStorage.getItem('authToken');

  const CLOUDINARY_CLOUD_NAME = "dzbakfw3i";
  const CLOUDINARY_UPLOAD_PRESET = "ml_default";

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(obj.displayName);
        setparentName(obj.parentName);
        setemail(obj.email);
        setphone(obj.phone);
        setphone2(obj.phone2);
        setdob(mysqlToDDMMYYYY(obj.DateOfBirth));
        setaddress(obj.address);
        setimageurl(obj.image_url);
        setid(obj.id);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.Name);
        setparentName(obj.ParentName);
        setemail(obj.Email_Address);
        setphone(obj.MobileNo);
        setphone2(obj.MobileNo2);
        setdob(mysqlToDDMMYYYY(obj.DateOfBirth));
        setaddress(obj.Address);
        setimageurl(obj.ImageURL);
        setrole(obj.Role);
        setid(obj.Id);
      }
      setTimeout(() => {
        props.resetProfileFlag();
      }, 3000);
    }
  }, [props.success, imageurl]);

  const mysqlToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const onSelectFile = (e) => {
    if (!e.target.files?.length) return;
    const reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = () => setImageSrc(reader.result);
  };

  const handleSave = async () => {
    if (!imageSrc || !croppedAreaPixels) return;
    const cropped = await getCroppedImg(imageSrc, croppedAreaPixels);
    setFinalImage(cropped);
  };

  const urlToBlob = async (url) => {
    const res = await fetch(url);
    return await res.blob();
  };

  const uploadBlobToCloudinary = async (blob) => {
    const fd = new FormData();
    fd.append("file", blob);
    fd.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

    const res = await fetch(`https://staging-api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {
      method: "POST",
      body: fd,
    });

    const json = await res.json();
    return json.secure_url;
  };

  const formatPhone = (phone) => {
    const number = phone.replace(/\D/g, "");

    if (number.startsWith("91")) {
      return `+91 ${number.slice(2, 7)}-${number.slice(7)}`;
    }

    return phone;
  };

  const handleStudentProfileSubmit = async (values) => {
    try {
      setLoading(true);
      setError("");

      let profileImageUrl = imageurl;

      if (finalImage) {
        const blob = await urlToBlob(finalImage);
        profileImageUrl = await uploadBlobToCloudinary(blob);
      }

      const [d, m, y] = dob.split("-");
      const mysqlDate = `${y}-${m}-${d}`;

      const payload = {
        id,
        name: values.fullName,
        parentName: values.parentName,
        dob: mysqlDate,
        imageUrl: profileImageUrl,
        mobileNo: formatPhone(values.phone),
        alternateNo: formatPhone(values.phone2),
        address: values.address
      };

      const res = await fetch("https://api.kunalsdrumclass.com/api/UpdateStudentProfile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Profile update failed");

      await Swal.fire({
        title: "Success!",
        text: `profile updated successfully!`,
        icon: "success",
        customClass: {
          popup: "swal2-material-ui",
          confirmButton: "btn btn-sm rounded-8 btn-primary",
        },
      });

      const storedUser = JSON.parse(localStorage.getItem("authUser"));
      const updatedUser = {
        ...storedUser,
        ImageURL: profileImageUrl,
        MobileNo: formatPhone(values.phone),
        MobileNo2: formatPhone(values.phone2),
        Name: values.fullName,
        ParentName: values.parentName,
        Address: values.address
      };
      localStorage.setItem("authUser", JSON.stringify(updatedUser));

      const authUsers = JSON.parse(localStorage.getItem("authUsers")) || [];
      const updatedAuthUsers = authUsers.map(user => {
        if (user.Id === id) {
          return {
            ...user,
            ImageURL: profileImageUrl,
            MobileNo: formatPhone(values.phone),
            MobileNo2: formatPhone(values.phone2),
            Name: values.fullName,
            ParentName: values.parentName,
            Address: values.address
          };
        }
        return user;
      });
      localStorage.setItem("authUsers", JSON.stringify(updatedAuthUsers));

      setimageurl(profileImageUrl);
      setFinalImage(null);
      setImageSrc(null);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleUserProfileSubmit = async (values) => {
    try {
      setLoading(true);
      setError("");

      let profileImageUrl = imageurl;

      if (finalImage) {
        const blob = await urlToBlob(finalImage);
        profileImageUrl = await uploadBlobToCloudinary(blob);
      }

      const payload = {
        id,
        name: values.fullName,
        imageUrl: profileImageUrl,
        mobileNo: formatPhone(values.phone)
      };

      const res = await fetch("https://api.kunalsdrumclass.com/api/UpdateUserProfile", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Profile update failed");

      await Swal.fire({
        title: "Success!",
        text: `profile updated successfully!`,
        icon: "success",
        customClass: {
          popup: "swal2-material-ui",
          confirmButton: "btn btn-sm rounded-8 btn-primary",
        },
      });

      const storedUser = JSON.parse(localStorage.getItem("authUser"));
      const updatedUser = {
        ...storedUser,
        ImageURL: profileImageUrl,
        MobileNo: formatPhone(values.phone),
        Name: values.fullName,
      };
      localStorage.setItem("authUser", JSON.stringify(updatedUser));

      const authUsers = JSON.parse(localStorage.getItem("authUsers")) || [];
      const updatedAuthUsers = authUsers.map(user => {
        if (user.Id === id) {
          return {
            ...user,
            Name: values.fullName,
            MobileNo: formatPhone(values.phone),
            ImageURL: profileImageUrl,
          };
        }
        return user;
      });
      localStorage.setItem("authUsers", JSON.stringify(updatedAuthUsers));

      setimageurl(profileImageUrl);
      setFinalImage(null);
      setImageSrc(null);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordSubmit = async (values) => {
    try {
      setError("");
      setLoading(true);

      if (!values.password || !values.confirmpassword) {
        setError("Please fill all password fields");
        return;
      }

      if (values.password !== values.confirmpassword) {
        setError("Passwords do not match");
        return;
      }

      const payload = {
        emailAddress: email,
        oldPassword: values.oldpassword,
        password: values.password,
        role
      };

      const res = await fetch("https://api.kunalsdrumclass.com/api/ChangePassword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      if (data.recordsets?.[0][0].Status === 1) {
        setError("Old password is incorrect!");
      } else {
        await Swal.fire({
          title: "Success!",
          text: `password changed successfully!`,
          icon: "success",
          customClass: {
            popup: "swal2-material-ui",
            confirmButton: "btn btn-sm rounded-8 btn-primary",
          },
        });

        passwordFormik.resetForm();
        setShowPassword(false);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const studentFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id,
      fullName: name || "",
      parentName: parentName || "",
      email: email || "",
      phone: phone || "",
      phone2: phone2 || "",
      dob: dob || "",
      address: address || "",
      role
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Please Enter Full Name"),
      parentName: Yup.string().required("Please Enter Parent Name"),
      phone: Yup.string().required("Please Enter Mobile No"),
      phone2: Yup.string().required("Please Enter Alternate Mobile No"),
      dob: Yup.string().required("Please Enter Date of Birth"),
      address: Yup.string().required("Please Enter Address"),
    }),
    onSubmit: handleStudentProfileSubmit
  });

  const userFormik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id,
      fullName: name || "",
      email: email || "",
      phone: phone || "",
      role
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Please Enter Full Name"),
      phone: Yup.string().required("Please Enter Mobile No"),
    }),
    onSubmit: handleUserProfileSubmit
  });

  const passwordFormik = useFormik({
    initialValues: {
      id,
      oldpassword: "",
      password: "",
      confirmpassword: "",
      role
    },
    validationSchema: Yup.object({
      oldpassword: Yup.string().required("Please Enter Old Password"),
      password: Yup.string().required("Please Enter New Password"),
      confirmpassword: Yup.string().required("Please Enter Confirm Password"),
    }),
    onSubmit: handlePasswordSubmit
  });

  document.title = "Profile | KDC - Kunal's Drum Class";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Profile"
            breadcrumbItems={[
              { title: "Profile" }
            ]}
          />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="mx-3">
                      <img
                        src={imageurl ? imageurl : 'https://res.cloudinary.com/dzbakfw3i/image/upload/v1770116479/profile.png'}
                        alt="kdc"
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Card>
            <CardBody>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: activeTab === "1",
                    })}
                    onClick={() => {
                      setActiveTab("1")
                    }}
                  >
                    Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      active: activeTab === "2",
                    })}
                    onClick={() => {
                      setActiveTab("2")
                    }}
                  >
                    Change Password
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent activeTab={activeTab} className="p-3 text-muted">
                <TabPane tabId="1">
                  <Row>
                    <Col sm="12">
                      <CardText className="mb-0">
                        {loading ? (
                          <div className="text-center my-4">
                            <Spinner color="primary" />
                          </div>
                        ) : (
                          role === "Student" ? (
                            <Form
                              className="form-horizontal"
                              onSubmit={studentFormik.handleSubmit}
                            >
                              <div className="row">
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Full Name*</Label>
                                    <Input
                                      name="fullName"
                                      className="form-control"
                                      type="text"
                                      onChange={studentFormik.handleChange}
                                      onBlur={studentFormik.handleBlur}
                                      value={studentFormik.values.fullName || ""}
                                      invalid={
                                        studentFormik.touched.fullName && studentFormik.errors.fullName ? true : false
                                      }
                                    />
                                    {studentFormik.touched.fullName && studentFormik.errors.fullName ? (
                                      <FormFeedback type="invalid">{studentFormik.errors.fullName}</FormFeedback>
                                    ) : null}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Parent Name*</Label>
                                    <Input
                                      name="parentName"
                                      className="form-control"
                                      type="text"
                                      onChange={studentFormik.handleChange}
                                      onBlur={studentFormik.handleBlur}
                                      value={studentFormik.values.parentName || ""}
                                      invalid={
                                        studentFormik.touched.parentName && studentFormik.errors.parentName ? true : false
                                      }
                                    />
                                    {studentFormik.touched.parentName && studentFormik.errors.parentName ? (
                                      <FormFeedback type="invalid">{studentFormik.errors.parentName}</FormFeedback>
                                    ) : null}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <label>Date Of Birth*</label>
                                  <div className="input-group">
                                    <Flatpickr
                                      className={`form-control d-block ${studentFormik.touched.dob && studentFormik.errors.dob
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      placeholder="dd-mm-yyyy"
                                      value={studentFormik.values.dob || ""}
                                      options={{
                                        dateFormat: "d-m-Y",
                                      }}
                                      onChange={(selectedDates, dateStr) => {
                                        studentFormik.setFieldValue("dob", dateStr);
                                      }}
                                      onBlur={() => studentFormik.setFieldTouched("dob", true)}
                                    />
                                    <div className="input-group-append">
                                      <span className="input-group-text">
                                        <i className="mdi mdi-calendar" />
                                      </span>
                                    </div>
                                    {studentFormik.touched.dob && studentFormik.errors.dob && (
                                      <FormFeedback className="d-block">
                                        {studentFormik.errors.dob}
                                      </FormFeedback>
                                    )}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Email*</Label>
                                    <Input
                                      name="email"
                                      className="form-control"
                                      type="text"
                                      disabled={true}
                                      onBlur={studentFormik.handleBlur}
                                      value={studentFormik.values.email || ""}
                                      invalid={
                                        studentFormik.touched.email && studentFormik.errors.email ? true : false
                                      }
                                    />
                                    {studentFormik.touched.email && studentFormik.errors.email ? (
                                      <FormFeedback type="invalid">{studentFormik.errors.email}</FormFeedback>
                                    ) : null}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group no-phone-label">
                                    <Label className="form-label">Mobile No*</Label>
                                    <PhoneInput
                                      country="in"
                                      placeholder="+91 88888-88888"
                                      value={studentFormik.values.phone}
                                      inputClass={`form-control phone ${studentFormik.touched.phone && studentFormik.errors.phone
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      inputStyle={{
                                        width: "-webkit-fill-available"
                                      }}
                                      inputProps={{
                                        name: "phone",
                                      }}
                                      onChange={(value) => {
                                        studentFormik.setFieldValue("phone", value, true);
                                      }}
                                      onBlur={() => {
                                        studentFormik.setFieldTouched("phone", true);
                                      }}
                                    />

                                    {studentFormik.touched.phone && studentFormik.errors.phone && (
                                      <div className="invalid-feedback d-block">
                                        {studentFormik.errors.phone}
                                      </div>
                                    )}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group no-phone-label">
                                    <Label className="form-label">Alternate Mobile No*</Label>
                                    <PhoneInput
                                      country="in"
                                      placeholder="+91 88888-88888"
                                      value={studentFormik.values.phone2}
                                      inputClass={`form-control phone ${studentFormik.touched.phone2 && studentFormik.errors.phone2
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      inputStyle={{
                                        width: "-webkit-fill-available"
                                      }}
                                      inputProps={{
                                        name: "phone2",
                                      }}
                                      onChange={(value) => {
                                        studentFormik.setFieldValue("phone2", value, true);
                                      }}
                                      onBlur={() =>
                                        studentFormik.setFieldTouched("phone2", true)
                                      }
                                    />

                                    {studentFormik.touched.phone2 &&
                                      studentFormik.errors.phone2 && (
                                        <FormFeedback className="d-block">
                                          {studentFormik.errors.phone2}
                                        </FormFeedback>
                                      )}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-12 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Address*</Label>

                                    <textarea
                                      name="address"
                                      rows={3}
                                      className={`form-control ${studentFormik.touched.address && studentFormik.errors.address
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      onChange={studentFormik.handleChange}
                                      onBlur={studentFormik.handleBlur}
                                      value={studentFormik.values.address || ""}
                                    />

                                    {studentFormik.touched.address && studentFormik.errors.address && (
                                      <div className="invalid-feedback">
                                        {studentFormik.errors.address}
                                      </div>
                                    )}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="form-label">Profile Image</label>
                                  <Dropzone
                                    accept={{ "image/*": [] }}
                                    multiple={false}
                                    onDrop={(acceptedFiles) => {
                                      const file = acceptedFiles[0];
                                      if (!file) return;

                                      const reader = new FileReader();
                                      reader.readAsDataURL(file);
                                      reader.onload = () => setImageSrc(reader.result);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        {...getRootProps()}
                                        className="border rounded p-4 text-center"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-2">
                                          <i className="mdi mdi-cloud-upload display-6 text-muted"></i>
                                        </div>
                                        <h6>Drop image here or click to upload/reupload</h6>
                                      </div>
                                    )}
                                  </Dropzone>
                                </div>

                                {/* Cropper BELOW upload */}
                                {imageSrc && (
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="mt-3" style={{ width: 300, height: 300, position: "relative" }}>
                                          <Cropper
                                            image={imageSrc}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={1}
                                            cropSize={{ width: 210, height: 210 }}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={onCropComplete}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        {finalImage && (
                                          <>
                                            <label className="form-label">Preview Profile</label>
                                            <div className="mt-3">
                                              <img
                                                src={finalImage}
                                                width={210}
                                                height={210}
                                                alt="Profile"
                                                style={{ borderRadius: "50%", border: "1px solid black" }}
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Crop button */}
                                <div className="col-md-3">
                                  {imageSrc && (
                                    <button type="button" className="btn btn-primary mt-3" onClick={handleSave}>
                                      Crop Image
                                    </button>
                                  )}
                                </div>

                                <div className="text-center mt-4">
                                  <Button type="submit" color="primary" disabled={loading || (imageSrc && !finalImage)}>
                                    Update Profile
                                  </Button>
                                </div>
                              </div>
                              {error && <p className="text-danger mt-2">{error}</p>}
                            </Form>
                          ) : (
                            <Form
                              className="form-horizontal"
                              onSubmit={userFormik.handleSubmit}
                            >
                              <div className="row">
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Full Name*</Label>
                                    <Input
                                      name="fullName"
                                      className="form-control"
                                      type="text"
                                      onChange={userFormik.handleChange}
                                      onBlur={userFormik.handleBlur}
                                      value={userFormik.values.fullName || ""}
                                      invalid={
                                        userFormik.touched.fullName && userFormik.errors.fullName ? true : false
                                      }
                                    />
                                    {userFormik.touched.fullName && userFormik.errors.fullName ? (
                                      <FormFeedback type="invalid">{userFormik.errors.fullName}</FormFeedback>
                                    ) : null}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group">
                                    <Label className="form-label">Email*</Label>
                                    <Input
                                      name="email"
                                      className="form-control"
                                      type="text"
                                      disabled={true}
                                      onBlur={userFormik.handleBlur}
                                      value={userFormik.values.email || ""}
                                      invalid={
                                        userFormik.touched.email && userFormik.errors.email ? true : false
                                      }
                                    />
                                    {userFormik.touched.email && userFormik.errors.email ? (
                                      <FormFeedback type="invalid">{userFormik.errors.email}</FormFeedback>
                                    ) : null}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3">
                                  <div className="form-group no-phone-label">
                                    <Label className="form-label">Mobile No*</Label>
                                    <PhoneInput
                                      country="in"
                                      placeholder="+91 88888-88888"
                                      value={userFormik.values.phone}
                                      inputClass={`form-control phone ${userFormik.touched.phone && userFormik.errors.phone
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                      inputStyle={{
                                        width: "-webkit-fill-available"
                                      }}
                                      inputProps={{
                                        name: "phone",
                                      }}
                                      onChange={(value) => {
                                        userFormik.setFieldValue("phone", value, true);
                                      }}
                                      onBlur={() => {
                                        userFormik.setFieldTouched("phone", true);
                                      }}
                                    />

                                    {userFormik.touched.phone && userFormik.errors.phone && (
                                      <div className="invalid-feedback d-block">
                                        {userFormik.errors.phone}
                                      </div>
                                    )}
                                    <Input name="id" value={id} type="hidden" />
                                  </div>
                                </div>
                                <div className="col-lg-6 mb-3"></div>
                                <div className="col-md-3 mt-3">
                                  <label className="form-label">Profile Image</label>
                                  <Dropzone
                                    accept={{ "image/*": [] }}
                                    multiple={false}
                                    onDrop={(acceptedFiles) => {
                                      const file = acceptedFiles[0];
                                      if (!file) return;

                                      const reader = new FileReader();
                                      reader.readAsDataURL(file);
                                      reader.onload = () => setImageSrc(reader.result);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        {...getRootProps()}
                                        className="border rounded p-4 text-center"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <input {...getInputProps()} />
                                        <div className="mb-2">
                                          <i className="mdi mdi-cloud-upload display-6 text-muted"></i>
                                        </div>
                                        <h6>Drop image here or click to upload/reupload</h6>
                                      </div>
                                    )}
                                  </Dropzone>
                                </div>

                                {/* Cropper BELOW upload */}
                                {imageSrc && (
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-md-6">
                                        <div className="mt-3" style={{ width: 300, height: 300, position: "relative" }}>
                                          <Cropper
                                            image={imageSrc}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={1}
                                            cropSize={{ width: 210, height: 210 }}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={onCropComplete}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        {finalImage && (
                                          <>
                                            <label className="form-label">Preview Profile</label>
                                            <div className="mt-3">
                                              <img
                                                src={finalImage}
                                                width={210}
                                                height={210}
                                                alt="Profile"
                                                style={{ borderRadius: "50%", border: "1px solid black" }}
                                              />
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}

                                {/* Crop button */}
                                <div className="col-md-3">
                                  {imageSrc && (
                                    <button type="button" className="btn btn-primary mt-3" onClick={handleSave}>
                                      Crop Image
                                    </button>
                                  )}
                                </div>

                                <div className="text-center mt-4">
                                  <Button type="submit" color="primary" disabled={loading || (imageSrc && !finalImage)}>
                                    Update Profile
                                  </Button>
                                </div>
                              </div>
                              {error && <p className="text-danger mt-2">{error}</p>}
                            </Form>
                          )
                        )}
                      </CardText>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabId="2">
                  <Row>
                    <Col sm="12">
                      <CardText className="mb-0">
                        {loading ? (
                          <div className="text-center my-4">
                            <Spinner color="primary" />
                          </div>
                        ) : (
                          <Form
                            className="form-horizontal"
                            onSubmit={passwordFormik.handleSubmit}
                          >
                            <div className="row">
                              <div className="col-lg-6 mb-3">
                                <div className="form-group">
                                  <Label className="form-label">Old Password*</Label>
                                  <div className="input-group">
                                    <Input
                                      name="oldpassword"
                                      className="form-control"
                                      type={showPassword ? "text" : "password"}
                                      onChange={passwordFormik.handleChange}
                                      onBlur={passwordFormik.handleBlur}
                                      value={passwordFormik.values.oldpassword || ""}
                                      invalid={
                                        passwordFormik.touched.oldpassword &&
                                        Boolean(passwordFormik.errors.oldpassword)
                                      }
                                    />
                                    <span
                                      className="input-group-text"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => setShowPassword(!showPassword)}
                                    >
                                      <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                    </span>
                                  </div>
                                  <Input name="id" value={id} type="hidden" />
                                  {passwordFormik.touched.oldpassword && passwordFormik.errors.oldpassword && (
                                    <FormFeedback className="d-block">
                                      {passwordFormik.errors.oldpassword}
                                    </FormFeedback>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3"></div>
                              <div className="col-lg-6 mb-3">
                                <div className="form-group">
                                  <Label className="form-label">New Password*</Label>
                                  <div className="input-group">
                                    <Input
                                      name="password"
                                      className="form-control"
                                      type={showPassword ? "text" : "password"}
                                      onChange={passwordFormik.handleChange}
                                      onBlur={passwordFormik.handleBlur}
                                      value={passwordFormik.values.password || ""}
                                      invalid={
                                        passwordFormik.touched.password &&
                                        Boolean(passwordFormik.errors.password)
                                      }
                                    />
                                    <span
                                      className="input-group-text"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => setShowPassword(!showPassword)}
                                    >
                                      <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                    </span>
                                  </div>
                                  <Input name="id" value={id} type="hidden" />
                                  {passwordFormik.touched.password && passwordFormik.errors.password && (
                                    <FormFeedback className="d-block">
                                      {passwordFormik.errors.password}
                                    </FormFeedback>
                                  )}
                                </div>
                              </div>
                              <div className="col-lg-6 mb-3">
                                <div className="form-group">
                                  <Label className="form-label">Confirm Password*</Label>
                                  <div className="input-group">
                                    <Input
                                      name="confirmpassword"
                                      className="form-control"
                                      type={showPassword ? "text" : "password"}
                                      onChange={passwordFormik.handleChange}
                                      onBlur={passwordFormik.handleBlur}
                                      value={passwordFormik.values.confirmpassword || ""}
                                      invalid={
                                        passwordFormik.touched.confirmpassword &&
                                        Boolean(passwordFormik.errors.confirmpassword)
                                      }
                                    />
                                    <span
                                      className="input-group-text"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => setShowPassword(!showPassword)}
                                    >
                                      <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                    </span>
                                  </div>
                                  <Input name="id" value={id} type="hidden" />
                                  {passwordFormik.touched.confirmpassword && passwordFormik.errors.confirmpassword && (
                                    <FormFeedback className="d-block">
                                      {passwordFormik.errors.confirmpassword}
                                    </FormFeedback>
                                  )}
                                </div>
                              </div>
                              {error && <p className="text-danger mt-2">{error}</p>}
                              <div className="text-center mt-4">
                                <Button type="submit" color="primary" disabled={loading}>
                                  Change Password
                                </Button>
                              </div>
                            </div>
                          </Form>
                        )}
                      </CardText>
                    </Col>
                  </Row>
                </TabPane>
              </TabContent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment >
  );
};

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
);
